<template>
  <!-- MODAL -->
  <TransitionRoot as="template" :show="open">
    <Dialog class="relative z-50" @close="closeDialog">
      <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0" enter-to="opacity-100" leave="ease-in duration-200" leave-from="opacity-100" leave-to="opacity-0">
        <div class="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
      </TransitionChild>

      <div class="fixed inset-0 z-10 w-screen overflow-y-auto">
        <div class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <TransitionChild as="template" enter="ease-out duration-300" enter-from="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95" enter-to="opacity-100 translate-y-0 sm:scale-100" leave="ease-in duration-200" leave-from="opacity-100 translate-y-0 sm:scale-100" leave-to="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95">
            <DialogPanel class="relative transform overflow-hidden rounded-lg bg-white px-8 pb-8 pt-6 text-left shadow-xl transition-all sm:my-8 sm:w-full lg:max-w-4xl sm:p-6">
              <!-- Conteiner de título e botão de fechar -->
              <div class="flex justify-between items-start">
                <h2 class="text-xl font-bold leading-9 tracking-tight text-gray-900">{{ title }}</h2>
                <button @click="closeDialog" type="button" class="text-gray-400 hover:text-gray-600 -mt-4">
                  <span class="sr-only">Fechar</span>
                  <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor" stroke-width="2">
                    <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                  </svg>
                </button>
              </div>
              <!-- Formulário principal com flex -->
              <div class="mt-4">
                <form class="flex flex-wrap gap-4" @submit="sendData" method="POST">
                 <div class="flex flex-wrap gap-4">
                    <!-- Apólice (input + lista simples) -->
                      <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                        <label for="apolice_search" class="block text-sm font-medium leading-6 text-gray-900">
                          Apólice
                        </label>

                       <input
                          id="apolice_search"
                          type="text"
                          v-model="apoliceQuery"
                          @input="onSearchApolice"
                          autocomplete="off"
                          class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                          placeholder="Digite pelo menos 4 letras..."
                        />

                        <!-- Lista simples -->
                        <div
                          v-if="apoliceQuery?.trim()?.length >= 4 && apoliceResults.length"
                          class="mt-2 rounded-md shadow-sm ring-1 ring-inset ring-gray-300 bg-white overflow-hidden"
                        >
                          <button
                            v-for="item in apoliceResults"
                            :key="item.id"
                            type="button"
                            @click="selectApolice(item)"
                            class="w-full text-left px-3 py-2 text-sm text-gray-900 hover:bg-gray-50"
                          >
                            {{ item.numero }}
                          </button>
                        </div>
                        <p
                          v-else-if="apoliceQuery?.trim()?.length >= 4 && !apoliceResults.length"
                          class="mt-2 text-xs text-gray-500"
                        >
                          Nenhuma apólice encontrada.
                        </p>
                        <!-- ID real selecionado -->
                        <input type="hidden" v-model="data.apolice_id" />
                      </div>
                    <!-- Competência -->
                    <div class="flex-1 min-w-[300px] sm:min-w-[300px] lg:w-1/2">
                      <label
                        for="competencia"
                        class="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Competência
                      </label>

                      <input
                        id="competencia"
                        name="competencia"
                        type="month"
                        v-model="data.competencia"
                        required
                        class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                      />
                    </div>

                    <!-- Observação -->
                    <div class="flex-1 min-w-[300px] lg:w-1/2">
                      <label for="ipca_valor" class="block text-sm font-medium leading-6 text-gray-900">
                        Valor IPCA Manual (Opcional)
                      </label>
                      <input
                        id="ipca_valor"
                        name="ipca_valor"
                        type="number"
                        step="0.0001"
                        v-model="data.ipca_valor"
                        class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        placeholder="Ex: 5.42"
                      />
                      <p class="mt-1 text-xs text-gray-500">Deixe vazio para usar o cálculo automático.</p>
                    </div>

                    <!-- Observação -->
                    <div class="w-full">
                      <label
                        for="observacao"
                        class="block text-sm font-medium leading-6 text-gray-900"
                      >
                        Observação
                      </label>

                      <textarea
                        id="observacao"
                        name="observacao"
                        rows="3"
                        v-model="data.observacao"
                        class="mt-2 block w-full rounded-md border-0 py-1.5 px-2 text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 focus:ring-2 focus:ring-inset focus:ring-indigo-600 sm:text-sm sm:leading-6"
                        placeholder="Ex: Movimentação prévia gerada para revisar inclusões/alterações antes do fechamento."
                      ></textarea>
                    </div>
                  </div>
                  <!-- Botão de enviar formulário -->
                  <div class="w-full">
                    <button type="submit" class="flex w-full justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-sm font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500">Cadastrar</button>
                  </div>
                </form>
              </div>
            </DialogPanel>
          </TransitionChild>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>

<script>

import ApolicesRepository from '@/services/ApolicesRepository.vue';
import { Dialog, DialogPanel, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { pageVariables } from '@/views/insideviews/movimentacao/PageVariablesMovimentacao';
import { handleUnauthorized } from '@/services/AuthSer/authServiceFunction';
import debounce from 'lodash/debounce';


  export default {
    name: 'MovimentacaoForm',
    async created(){
      this.buscarApolices = debounce((...args) => {
        this._buscarApolices(...args);
      }, 400);
    },
    props: {
      title: {
        type: String,
        required: true
      },
      open: {
        type: Boolean,
        required: true
      },
    },  
    watch: {
    }, 
    data() {
      return {
        apoliceQuery: "",
        apoliceResults: [],
        apoliceTimer: null,
        data: {
          apolice_id: null,
          competencia: "",
          observacao: "",
          ipca_valor: null,
        },
        ...pageVariables,
        onlineUser: JSON.parse(window.localStorage.getItem("myUser")),
      };
    },
    methods: {
      sendData(e) {
        e.preventDefault();
        
        if (!this.data.apolice_id) {
          alert('Por favor, selecione uma apólice da lista.');
          return;
        }

        this.$emit('data', this.data);
      },
      closeDialog() {
        this.$emit('update-open', false);
      },
       onSearchApolice() {
        this.data.apolice_id = null; 
        this.buscarApolices();
      },

      async _buscarApolices() {
        const q = (this.apoliceQuery || "").trim();

        if (q.length < 4) {
          this.apoliceResults = [];
          return;
        }

        const apolicesRepo = new ApolicesRepository();
        try {
          const response = await apolicesRepo.searchApolices(
            this.searchPage,               // ex: "/api/apolices"
            this.onlineUser.token,
            q
          );
         
          if (response?.status === 200) {
            this.apoliceResults = response.data || [];
          } else {
            this.apoliceResults = [];
            this.error = response?.message;
          }
        } catch (error) {
          this.apoliceResults = [];
          handleUnauthorized(error);
        }
      },

      selectApolice(item) {
        this.data.apolice_id = item.id;
        this.apoliceQuery = item.numero;
        this.apoliceResults = [];
      },
    },
    components:{
      Dialog,
      DialogPanel, 
      TransitionChild, 
      TransitionRoot,
    },
  }
</script>